import { PasswordSecurityData } from './passwordSecurity.types';

export interface PasswordSecurityState {
  data: PasswordSecurityData;
  loading: boolean;
  error: any;
}

export const defaultState: PasswordSecurityState = {
  data: {
    petentLevel: 'default',
    petentAllowSkip: true,
    applicantLevel: 'default',
    applicantAllowSkip: true,
  },
  loading: false,
  error: null,
};
